import { App } from 'antd';
import { useCallback } from 'react';
import { DormitoryLegacyHttp } from '@/services';
import { useTranslation } from 'react-i18next';

export default function useDormitoryGroupConfirm() {
  const { modal, message } = App.useApp();
  const [t] = useTranslation(['common', 'dormitory']);

  const groupRoomConfirm = useCallback((room: DormitoryFloorRoomEntity, callback: any = undefined) => {
    modal.confirm({
      type: 'warn',
      okText: t('common:labels.yes'),
      cancelText: t('common:labels.no'),
      content: t('dormitory:messages.confirm-choose-room', { code: room?.code }),
      onOk: async () => {
        try {
          await DormitoryLegacyHttp.updateDormitoryGroup({
            solitary: false,
            dormitoryRoomId: room.id,
          });
          message.success(t('common:messages.request-success-submit'));
          if (typeof callback === 'function')
            callback();
        }
        catch (e) {
          console.error(e);
        }
      }
    });
  }, [message, modal, t]);

  const solitaryRoomConfirm = useCallback((func: 'create' | 'update', dormitoryId: number, room: DormitoryFloorRoomEntity, callback: any = undefined) => {
    return modal.confirm({
      type: 'warn',
      okText: t('common:labels.yes'),
      cancelText: t('common:labels.no'),
      content: t('dormitory:messages.confirm-choose-room', { code: room?.code }),
      onOk: async () => {
        try {
          const fn = func === 'create' ? DormitoryLegacyHttp.createDormitoryGroup : DormitoryLegacyHttp.updateDormitoryGroup;
          await fn({
            dormitoryId,
            solitary: true,
            dormitoryRoomId: room.id,
            roomSize: room.roomSize,
          });
          message.success(t('common:messages.request-success-submit'));
          if (typeof callback === 'function')
            callback();
        }
        catch (e) {
          console.error(e);
        }
      }
    });
  }, [message, modal, t]);

  return { solitaryRoomConfirm, groupRoomConfirm };
}
